import React from 'react';
import {
  Box,
  Dialog,
  Drawer,
  useMediaQuery,
  useTheme,
} from '@mui/material';

const ResizableDrawerShell = ({
  children,
  drawerWidth,
  drawerMode = 'wide',
  isResizing,
  onClose,
  onResetWidth,
  onStartResize,
  open,
}) => {
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up('md'));
  const isFullscreen = drawerMode === 'fullscreen' || !isDesktop;
  const effectiveWidth = drawerMode === 'compact'
    ? Math.min(drawerWidth, 720)
    : drawerWidth;

  if (isFullscreen) return <Dialog fullScreen open={open} onClose={onClose}>{children}</Dialog>;

  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      PaperProps={{ sx: { width: effectiveWidth, maxWidth: '100vw', overflow: 'visible', transition: isResizing ? 'none' : 'width 120ms ease-out' } }}
    >
      <Box
        role="separator"
        aria-orientation="vertical"
        aria-label="Resize drawer"
        onPointerDown={onStartResize}
        onDoubleClick={onResetWidth}
        title="Drag to resize - double-click to reset to 80%"
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: 8,
          height: '100%',
          cursor: 'col-resize',
          zIndex: (currentTheme) => currentTheme.zIndex.drawer + 1,
          transform: 'translateX(-4px)',
          touchAction: 'none',
          '&::before': {
            content: '""',
            position: 'absolute',
            top: 0,
            bottom: 0,
            left: 3,
            width: 2,
            bgcolor: isResizing ? 'primary.main' : 'transparent',
            transition: 'background-color 120ms',
          },
          '&:hover::before': { bgcolor: 'primary.main' },
        }}
      />
      <Box sx={{ height: '100%', overflow: 'auto' }}>{children}</Box>
    </Drawer>
  );
};

export default ResizableDrawerShell;
